import { useForm, Controller } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import {
  createNewSite,
  updateSite,
//  editSiteSn,
  clearSubmitSiteError,
  selectSitesState,
  modifySite,
} from '../../redux/slices/sitesSlice';
import { format } from 'date-fns';
import { ContactPayload, EquipementState, SitePayload, SiteState } from '../../redux/types';
import { getPiscineInfos, piscineFields, getSDetailRegister, getClimInfos, getVentilInfos, getEcsInfos, getChauffInfos, chauffFields, ecsFields, climFields, getPlaquesInfos, getFourInfos, plaquesFields, fourFields, ventilFields } from '../../types/siteDetailsInfos';
import ErrorBox from '../../components/ErrorBox';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import IconDashboard from '@material-ui/icons/Dashboard';
import InfoIcon from '@material-ui/icons/Info';

import {
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  Button,
  InputAdornment,
  FormLabel,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  InputLabel,
  MenuItem,
  Select,
  OutlinedInput,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Divider,
  Paper,
} from '@material-ui/core';
import { useFormStyles, useMainPageStyles, useTableStyles } from '../../styles/muiStyles';
import DateIcon from '@material-ui/icons/DateRangeTwoTone';
import SubjectIcon from '@material-ui/icons/Subject';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { MultiSelectTreeViewProps } from '@material-ui/lab';
import { SelectProps } from '@material-ui/core';
import AppMenu from '../../components/AppMenu';
import { MultiSelect } from "react-multi-select-component";
import { createContact, updateContact } from '../../redux/slices/contactsSlice';
import { autoLogin } from '../../redux/slices/authSlice';
import { fetchConcentrateursForSiteSn } from '../../redux/slices/concentrateursSlice';
import { fetchEquipementsBySitesSn, fetchEquipementsForSiteSn, selectEquipementsState } from '../../redux/slices/equipementsSlice';
import { arrayIncludes } from '@material-ui/pickers/_helpers/utils';

const validationSchema = yup.object({
  site_sn: yup
    .string()
    .required('Required')
    .min(3, 'Must be at least 3 characters')
    .max(60, 'Must be at most 60 characters'),

  cpt_type: yup.string().required('Required'),
});

export type occupationProps = {
  siteId: string;
  range: string;
  nombre: number;
  taux: number;
}
type statsOccup = {
  [key:string]: occupationProps[];
}

interface SiteCreationProps {
  closeDialog?: () => void;
  isEditMode: boolean;
  isMobile: boolean;
}

const SiteCreation: React.FC<SiteCreationProps> = ({
  closeDialog,
  isEditMode,
  isMobile,
}) => {
  const classes = useFormStyles();
  const classes3 = useMainPageStyles();
  const classes2 = useTableStyles();
  const dispatch = useDispatch();
  const { submitError, submitLoading } = useSelector(selectSitesState);
  let contact = { id: "", nom: "", prenom: "" , mail: "", tel: "", adresse: "", code_postal: "", actif: true, revenus: "", remarques: "", site_id: [], site_sn: [] };
   
  const chauffDetail: string[][] = []
  let currentData = { sn_site: '',  contacts: [], date_instru: null, date_end: null, date_update: null, concentrateur: [], gmt_date: 2,
    tx_occupation: [],  type_inst_elec: '',  index_cpt_elec: null,  index_cpt_hc: null,  tarif_elec: '',  puiss_sscrite: '',  prm_linky: null,
    adresse: '',  code_postal: null,  instrum_by: '',  nature: '',  surface: null,  surf_unused: null,  surf_nonchauff: null,  niveaux: null,  rq_instru: '',
    chauff_nrj: [],  chauff_detail: [],  chauff_rq: [],  ecs_nrj: [],  ecs_detail: [],  ecs_rq: [],  ventil_type: [],  ventil_detail: [],  ventil_rq: [],
    clim_type: [],  clim_detail: [],  clim_rq: [],  piscine_infos: [],  cuissonplq_nrj: [],  cuissonplq_detail: [],  cuissonplq_rq: [],  four_type: [],
    four_detail: [],  four_rq: [],  veilles_app: [],  veilles_pw: [],  veilles_rq: [],  cpt_type: '',  chauff_id: [],  ecs_id: [],  ventil_id: [],  clim_id: [],
    piscine_id: [],  cuissonplq_id: [],  four_id: []
    }

  console.log("CurrentDatas: "+currentData?.ecs_nrj?.map((t)=>t+"-")+" / "+currentData?.ecs_detail?.map((t)=>t+"-")+" / "+currentData?.ecs_rq?.map((t)=>t+"-")+" / "
    +currentData?.chauff_nrj?.map((t)=>t+"-")+" / "+chauffDetail?.map((t)=>t.map((y)=>y+"-"))+" / "+currentData?.chauff_rq?.map((t)=>t+"-"))
  const infosPiscine = getPiscineInfos(currentData?.piscine_infos || [""])
  const infosClim = getClimInfos(currentData?.clim_type || [""], currentData?.clim_detail || [""], currentData?.clim_rq || [""])
  const infosVentil = getVentilInfos(currentData?.ventil_type || [""], currentData?.ventil_detail || [""], currentData?.ventil_rq || [""])
  const infosEcs = getEcsInfos(currentData?.ecs_nrj || [""], currentData?.ecs_detail || [""], currentData?.ecs_rq || [""])
  const infosChauff = getChauffInfos(currentData?.chauff_nrj || [""], chauffDetail/*currentData?.chauff_detail*/, currentData?.chauff_rq || [""])
  const infosPlaques = getPlaquesInfos(currentData?.cuissonplq_nrj || [""], currentData?.cuissonplq_detail || [""], currentData?.cuissonplq_rq || [""])
  const infosFour = getFourInfos(currentData?.four_type || [""], currentData?.four_detail || [""], currentData?.four_rq || [""])
  //  const infosChauff = getChauffInfos(chauffFields.map((cf) => cf.nrj), chauffFields.map((cf) => cf.detail), chauffFields.map((cf) => cf.rq))
  //contact?.revenus !== "Primaire" && contact?.revenus !== "Secondaire" ? contact.revenus = "-" : null
  const [selectedScenario, setSelectedScenario] = useState<String>("update");
  const radioHandlerScenar = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log("Changement de scénario ! #######################")
    setSelectedScenario((event.target as HTMLInputElement).value);
  };

  function LogementForm() {
    let set: Array<occupationProps> = []
    //let currOccupation: occupationProps[]
    set.push({ siteId: "0", range: "0-10", nombre: 0, taux: 0 })
    set.push({ siteId: "0", range: "11-17", nombre: 0, taux: 0 })
    set.push({ siteId: "0", range: "18-24", nombre: 0, taux: 0 })
    set.push({ siteId: "0", range: "25-59", nombre: 0, taux: 0 })
    set.push({ siteId: "0", range: "60-74", nombre: 0, taux: 0 })
    set.push({ siteId: "0", range: ">74", nombre: 0, taux: 0 })
    if(currentData !== undefined) {
      let index = 10
      currentData?.tx_occupation?.map((line) => {
        console.log("LINE OCCUPATION: "+line)
        let tab = line.split("|")
        if(line.length >= 1) {
          if(tab[0] === "0-10") { index = 0 }
          else if(tab[0] === "11-17") { index = 1 }
          else if(tab[0] === "18-24") { index = 2 }
          else if(tab[0] === "25-59") { index = 3 }
          else if(tab[0] === "60-74") { index = 4 }
          else if(tab[0] === ">74") { index = 5 }
          else { index = 10 }
        //  set.push({siteId: currentData.id, range: tab[0], nombre: Number(tab[1].replace("nb ","")), taux: Number(tab[2].replace("poids ","")) })
          if(index !== 10) {
            set[index] = {siteId: currentData.id, range: tab[0], nombre: Number(tab[1].replace("nb ","")), taux: Number(tab[2].replace("poids ",""))}
          }
        }
      })
    }
    
    const { register, control, handleSubmit, errors } = useForm({
      mode: 'onChange', // onSubmit
      defaultValues:
      {
        prenom: contact?.prenom || '',
        nom: contact?.nom || '',
        tel: contact?.tel || '',
        mail: contact?.mail || '',
        adresse: contact?.adresse || '',
        code_postal: contact?.code_postal || '',
        actif: contact?.actif || '',
        remarques: contact?.remarques || '',
        sn_site: currentData?.sn_site || '',
//        site_id: currentData?.id || '',
        gmt_date: currentData?.gmt_date || '',
        //date_update: currentData?.date_update, //date_update, //currentData?.date_update || new Date(),
        /*date_instru: currentData?.date_instru || '',
        date_end: currentData?.date_end || undefined,*/
        dateInstru: currentData?.date_instru || '',
        occupy_0_10_nb: set[0]?.nombre || '',
        occupy_11_17_nb: set[1]?.nombre || '',
        occupy_18_24_nb: set[2]?.nombre || '',
        occupy_25_59_nb: set[3]?.nombre || '',
        occupy_60_74_nb: set[4]?.nombre || '',
        occupy_74_nb: set[5]?.nombre || '',
        occupy_0_10_tx: set[0]?.taux || '',
        occupy_11_17_tx: set[1]?.taux || '',
        occupy_18_24_tx: set[2]?.taux || '',
        occupy_25_59_tx: set[3]?.taux || '',
        occupy_60_74_tx: set[4]?.taux || '',
        occupy_74_tx: set[5]?.taux || '',
      //  occupation: Array.from(statOccupy[currentData?.id || "0"]) as occupationProps[],
        cpt_type: currentData?.cpt_type || '',
        type_inst_elec: currentData?.type_inst_elec || '',
        index_cpt_elec: currentData?.index_cpt_elec || '',
        index_cpt_hc: currentData?.index_cpt_hc || '',
        puiss_sscrite: currentData?.puiss_sscrite || '',
        prm_linky: currentData?.prm_linky || '',
        adresseLgt: currentData?.adresse || '',
        code_postalLgt: currentData?.code_postal || '',
        instrum_by: currentData?.instrum_by || '',
        surface: currentData?.surface || '',
        surf_unused: currentData?.surf_unused || '',
        surf_nonchauff: currentData?.surf_nonchauff || '',
        niveaux: currentData?.niveaux || '',
//        date_update: currentData?.date_update || null,
        rq_instru: currentData?.rq_instru || '', // ? JSON.parse(currentData?.rq_instru) : '',
        chauff_nrj0: infosChauff?.[0].nrj || '',
        chauff_detail0: infosChauff?.[0].detail?.map((i) => i.length > 3 ? i+"," : null) || '',
        chauff_rq0: infosChauff?.[0].rq || '',
        chauff_nrj1: infosChauff?.[1].nrj || '',
        chauff_detail1: infosChauff?.[1].detail?.map((i) => i.length > 3 ? i+"," : null) || '',
        chauff_rq1: infosChauff?.[1].rq || '',
        chauff_nrj2: infosChauff?.[2].nrj || '',
        chauff_detail2: infosChauff?.[2].detail?.map((i) => i.length > 3 ? i+"," : null) || '',
        chauff_rq2: infosChauff?.[2].rq || '',
        ecs_nrj0: infosEcs?.[0].nrj || '',
        ecs_detail0: infosEcs?.[0].detail?.map((i) => i.length > 3 ? i+"," : null) || '',
        ecs_rq0: infosEcs?.[0].rq || '',
        ecs_nrj1: infosEcs?.[1].nrj || '',
        ecs_detail1: infosEcs?.[1].detail?.map((i) => i.length > 3 ? i+"," : null) || '',
        ecs_rq1: infosEcs?.[1].rq || '',
        cuissonplq_nrj0: infosPlaques?.[0].type || '',
        cuissonplq_detail0: infosPlaques?.[0].nbFeux || '',
        cuissonplq_rq0: infosPlaques?.[0].rq || '',
        cuissonplq_nrj1: infosPlaques?.[1].type || '',
        cuissonplq_detail1: infosPlaques?.[1].nbFeux || '',
        cuissonplq_rq1: infosPlaques?.[1].rq || '',
        four_type0: infosFour?.[0].type || '',
        four_detail0: infosFour?.[0].detail || '',
        four_rq0: infosFour?.[0].rq || '',
        four_type1: infosFour?.[1].type || '',
        four_detail1: infosFour?.[1].detail || '',
        four_rq1: infosFour?.[1].rq || '',
        ventil_type0: infosVentil?.[0].type || '',
        ventil_detail0: infosVentil?.[0].detail || '',
        ventil_rq0: infosVentil?.[0].rq || '',
        ventil_type1: infosVentil?.[1].type || '',
        ventil_detail1: infosVentil?.[1].detail || '',
        ventil_rq1: infosVentil?.[1].rq || '',
        ventil_type2: infosVentil?.[2].type || '',
        ventil_detail2: infosVentil?.[2].detail || '',
        ventil_rq2: infosVentil?.[2].rq || '',
        clim_type0: infosClim?.[0].type || '',
        clim_detail0: infosClim?.[0].detail || '',
        clim_rq0: infosClim?.[0].rq || '',
        clim_type1: infosClim?.[1].type || '',
        clim_detail1: infosClim?.[1].detail || '',
        clim_rq1: infosClim?.[1].rq || '',
        clim_type2: infosClim?.[2].type || '',
        clim_detail2: infosClim?.[2].detail || '',
        clim_rq2: infosClim?.[2].rq || '',
        piscine_infos_present: infosPiscine?.present || "",
        piscine_infos_type: infosPiscine.type || "",
        piscine_infos_chauffage: infosPiscine.chauffage || "",
        piscine_infos_lgdia: infosPiscine.longueurOrDiam || 0,
        piscine_infos_larg: infosPiscine.largeur || 0,
        piscine_infos_prof: infosPiscine.prof || 0,
        piscine_infos_consoppe: infosPiscine.consoPompe || "",
        piscine_infos_note: infosPiscine.note || "",
        chauff_id: currentData?.chauff_id,
        ecs_id: currentData?.ecs_id,
        ventil_id: currentData?.ventil_id,
        clim_id: currentData?.clim_id,
        piscine_id: currentData?.piscine_id,
        cuissonplq_id: currentData?.cuissonplq_id,
        four_id: currentData?.four_id,
        },
      });
    const [state, setState] = useState({
      //selectedRevenus: contact.revenus || "",
      contactID: contact?.id !== undefined ? contact.id : '',
      nature: currentData?.nature !== null ? currentData?.nature : 'Nature inconnue',
      dateEnd: currentData?.date_end || null,//undefined,
      dateInstru: currentData?.date_instru || null, //undefined,
      dateUpdate: currentData?.date_update || null,//date_update,//currentData?.date_update || new Date(),
      tarif_elec: currentData?.tarif_elec !== null ? currentData?.tarif_elec : 'Tarif inconnu',
      chauff_nrj0: infosChauff?.[0].nrj,
      chauff_detail0: infosChauff?.[0].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
      chauff_rq0: infosChauff?.[0].rq,
      chauff_nrj1: infosChauff?.[1].nrj,
      chauff_detail1: infosChauff?.[1].detail?.map((i) => i.length > 3 ? i+"," : ""),
      chauff_rq1: infosChauff?.[1].rq,
      chauff_nrj2: infosChauff?.[2].nrj,
      chauff_detail2: infosChauff?.[2].detail?.map((i) => i.length > 3 ? i+"," : ""),
      chauff_rq2: infosChauff?.[2].rq,
      cuissonplq_nrj0: infosPlaques?.[0].type || '',
      cuissonplq_detail0: infosPlaques?.[0].nbFeux || '',
      cuissonplq_nrj1: infosPlaques?.[1].type || '',
      cuissonplq_detail1: infosPlaques?.[1].nbFeux || '',
      four_type0: infosFour?.[0].type || '',
      four_type1: infosFour?.[1].type || '',
      ecs_nrj0: infosEcs?.[0].nrj,
      ecs_detail0: infosEcs?.[0].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
      ecs_rq0: infosEcs?.[0].rq,
      ecs_nrj1: infosEcs?.[1].nrj,
      ecs_detail1: infosEcs?.[1].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
      ecs_rq1: infosEcs?.[1].rq,
      ventil_type0: infosVentil?.[0].type,
      ventil_detail0: infosVentil?.[0].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
      ventil_rq0: infosVentil?.[0].rq,
      ventil_type1: infosVentil?.[1].type,
      ventil_detail1: infosVentil?.[1].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
      ventil_rq1: infosVentil?.[1].rq,
      ventil_type2: infosVentil?.[2].type,
      ventil_detail2: infosVentil?.[2].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
      ventil_rq2: infosVentil?.[2].rq,
      clim_type0: infosClim?.[0].type,
      clim_detail0: infosClim?.[0].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
      clim_rq0: infosClim?.[0].rq,
      clim_type1: infosClim?.[1].type,
      clim_detail1: infosClim?.[1].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
      clim_rq1: infosClim?.[1].rq,
      clim_type2: infosClim?.[2].type,
      clim_detail2: infosClim?.[2].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
      clim_rq2: infosClim?.[2].rq,
      chauff_id: currentData?.chauff_id,
      ecs_id: currentData?.ecs_id,
      ventil_id: currentData?.ventil_id,
      clim_id: currentData?.clim_id,
      piscine_id: currentData?.piscine_id,
      cuissonplq_id: currentData?.cuissonplq_id,
      four_id: currentData?.four_id,
      piscine_infos_present: infosPiscine.present,
      piscine_infos_type: infosPiscine.type,
      piscine_infos_chauffage: infosPiscine.chauffage,
      selectedRevenus: contact.revenus !== null && contact.revenus.length > 4 ? contact.revenus : "Revenus inconnus",
    });
    const selectChange = (event: React.ChangeEvent<{  name?: string | undefined; value: unknown; }>) => {
      console.log("################ e.taget.value: "+event.target.value)
      setState({ ...state, [event.target.name as string]: event.target.value })
//      setSelected(event.target.value as String)
    }
    function handleDateChg(evt: { target: { value: any; name: any; }; }) {
      console.log("handleDateChg: "+evt.target.name+" "+evt.target.value);
      const value = evt.target.value;
      setState({ ...state, [evt.target.name]: value });
    }
    const hdlSetChauff = (event: React.ChangeEvent<{  name?: string | undefined; value: unknown; }>) => {
      console.log("hdlSetChauff EVENT: "+event.target.name+": "+event.target.value);
      if(event.target.name as string === "chauff_nrj0") { state.chauff_detail0 = [] }
      if(event.target.name as string === "chauff_nrj1") { state.chauff_detail1 = [] }
      if(event.target.name as string === "chauff_nrj2") { state.chauff_detail2 = [] }
      if(event.target.name as string === "ecs_nrj0") { state.ecs_detail0 = [] }
      if(event.target.name as string === "ecs_nrj1") { state.ecs_detail1 = [] }
      setState({ ...state, [event.target.name as string]: event.target.value });
    }
    const onSubmit = handleSubmit((data/*{ firstName, lastName, age }*/) => {
      console.log(data)
      console.log(state)
      const theContact: ContactPayload = {
        contactId: '',
        nom: data.nom,
        site_sn: contact.site_sn,
        site_id: contact.site_id,
        prenom: data.prenom,
        tel: data.tel,
        mail: data.mail,
        adresse: data.adresse,
        code_postal: data.code_postal,
        actif: true,
        revenus: state.selectedRevenus,
        remarques: data.remarques,
      }
      const TxOccupation: Array<string> = []
      TxOccupation[0] = "0-10|nb "+data.occupy_0_10_nb+"|poids "+String(data.occupy_0_10_tx)
      TxOccupation[1] = "11-17|nb "+data.occupy_11_17_nb+"|poids "+String(data.occupy_11_17_tx)
      TxOccupation[2] = "18-24|nb "+data.occupy_18_24_nb+"|poids "+String(data.occupy_18_24_tx)
      TxOccupation[3] = "25-59|nb "+data.occupy_25_59_nb+"|poids "+String(data.occupy_25_59_tx)
      TxOccupation[4] = "60-74|nb "+data.occupy_60_74_nb+"|poids "+String(data.occupy_60_74_tx)
      TxOccupation[5] = ">74|nb "+data.occupy_74_nb+"|poids "+String(data.occupy_74_tx)
      console.log(TxOccupation.map((t)=>t+"#"));
      console.log("Puissance souscrite: "+data.puiss_sscrite)
      const logement : SitePayload = {
        id: '',
        siteId: '',//data.site_id,
        sn_site: data.sn_site,
        adresse: data.adresseLgt,
        contacts: currentData?.contacts,
        contactId: '', // TODO: API side : be carefull :create Contact, get Id, and use it on site creation
        date_instru: /*state*/data.dateInstru !== null ? new Date(String(/*state*/data.dateInstru)) : new Date(),// || undefined,
        date_end: state.dateEnd,// || undefined,
        date_update: state.dateUpdate || new Date(),//null,//new Date(), //state.dateUpdate || new Date(),//data.date_update, 
        concentrateur: currentData?.concentrateur,
        gmt_date: Number(data.gmt_date),
        tx_occupation: TxOccupation,
        type_inst_elec: data.type_inst_elec,
        index_cpt_elec : Number(data.index_cpt_elec),
        index_cpt_hc : Number(data.index_cpt_hc),
        tarif_elec : state.tarif_elec,
        puiss_sscrite : String(data.puiss_sscrite),
        prm_linky : Number(data.prm_linky),
        code_postal : Number(data.code_postalLgt),
        instrum_by : data.instrum_by,
        nature : state.nature,
        surface : Number(data.surface),
        surf_unused : Number(data.surf_unused),
        surf_nonchauff : Number(data.surf_nonchauff),
        niveaux : Number(data.niveaux),
        rq_instru : JSON.stringify(data.rq_instru),
        chauff_nrj : [state.chauff_nrj0 || '',state.chauff_nrj1 || '',state.chauff_nrj2 || ''],
        chauff_detail : [state.chauff_detail0?.flatMap((d)=>d).join('+') || '',state.chauff_detail1?.flatMap((d)=>d).join('+') || '',state.chauff_detail2?.flatMap((d)=>d).join('+') || ''],
        //chauff_rq : [state.chauff_rq0 || '',state.chauff_rq1 || '',state.chauff_rq2 || ''],
        chauff_rq : [String(data.chauff_rq0) || '',String(data.chauff_rq1) || '',String(data.chauff_rq2) || ''],
        ecs_nrj : [state.ecs_nrj0 || '',state.ecs_nrj1 || ''],
        ecs_detail : [state.ecs_detail0?.flatMap((d)=>d).join('+') || '',state.ecs_detail1?.flatMap((d)=>d).join('+') || ''],
        ecs_rq : [String(data.ecs_rq0) || '',String(data.ecs_rq1) || ''],
        ventil_type : [state.ventil_type0 || '',state.ventil_type1 || ''],
        ventil_detail : [state.ventil_detail0?.flatMap((d)=>d).join('+') || '',state.ventil_detail1?.flatMap((d)=>d).join('+') || ''],
        ventil_rq : [String(data.ventil_rq0) || '',String(data.ventil_rq1) || ''],
        clim_type : [state.clim_type0 || '',state.clim_type1 || ''],
        clim_detail : [state.clim_detail0?.flatMap((d)=>d).join('+') || '',state.clim_detail1?.flatMap((d)=>d).join('+') || ''],
        clim_rq : [String(data.clim_rq0) || '',String(data.clim_rq1) || ''],
        piscine_infos : [String(state.piscine_infos_present) || '',
          String(state.piscine_infos_type) || '',
          String(state.piscine_infos_chauffage) || '',
          String(data.piscine_infos_lgdia) || '',
          String(data.piscine_infos_larg) || '',
          String(data.piscine_infos_prof) || '',
          String(data.piscine_infos_consoppe) || '',
          String(data.piscine_infos_note) || ''
        ],
        cuissonplq_nrj : [state.cuissonplq_nrj0 || '',state.cuissonplq_nrj1 || ''],
        cuissonplq_detail : [state.cuissonplq_detail0 || '',state.cuissonplq_detail1 || ''],
        cuissonplq_rq : [String(data.cuissonplq_rq0) || '',String(data.cuissonplq_rq1) || ''],
        four_type : [state.four_type0 || '',state.four_type1 || ''],
        four_detail : [String(data.four_detail0) || '',String(data.four_detail1) || ''],
        four_rq : [String(data.four_rq0) || '',String(data.four_rq1) || ''],
        veilles_app : currentData?.veilles_app,
        veilles_pw : currentData?.veilles_pw,
        veilles_rq : currentData?.veilles_rq,
        cpt_type : data.cpt_type,
        chauff_id: [state.chauff_id?.flatMap((d)=>d).join(',') || ''],
        ecs_id: [state.ecs_id?.flatMap((d)=>d).join(',') || ''],
        ventil_id: [state.ventil_id?.flatMap((d)=>d).join(',') || ''],
        clim_id: [state.clim_id?.flatMap((d)=>d).join(',') || ''],
        piscine_id: [state.piscine_id?.flatMap((d)=>d).join(',') || ''],
        cuissonplq_id: [state.cuissonplq_id?.flatMap((d)=>d).join(',') || ''],
        four_id: [state.four_id?.flatMap((d)=>d).join(',') || ''],
      }
      console.log("PISCINE: "+logement.piscine_infos)
      dispatch(createNewSite( theContact, logement/*, closeDialog*/))
      window.location.replace("/")
      //window.location.replace("https://paneltracker.enertech.fr")
    });
    return (
      <><><form onSubmit={onSubmit/*handleSubmit(onSubmit/*handleUpdateContact*//*isEditMode ? handleUpdateContact : handleCreateContact)*/}>
      <Typography
        variant={isMobile ? 'h5' : 'h4'}
        color="secondary"
        style={{ marginRight: '0.2em', marginTop: '1.5rem' }}
      >Contact <SubjectIcon className={classes2.customIcon} />
      </Typography>
      <Table className={classes2.contactDetailsTable}>
      <TableBody>
        <TableRow>
          <TableCell colSpan={1}>
            <TextField margin='dense'
              //className={MoreClasses.tiersWidth}
              inputRef={register}
              name="prenom"
              id="prenom"
              type="text"
              label="Prénom"
              variant="outlined"
              fullWidth
              style={{ marginTop: '1.1em' }} /></TableCell>
          <TableCell colSpan={1}>
            <TextField margin='dense'
              //className={MoreClasses.tiersWidth}
              inputRef={register}
              name="nom"
              id="nom"
              type="text"
              label="Nom"
              variant="outlined"
              fullWidth
              style={{ marginTop: '1.1em' }} /></TableCell>
          <TableCell colSpan={1}>
            <TextField margin='dense'
              //className={MoreClasses.tiersWidth}
              inputRef={register}
              name="tel"
              id="tel"
              type="text"
              label="Téléphone"
              variant="outlined"
              fullWidth
              style={{ marginTop: '1.1em' }} /></TableCell>
          <TableCell colSpan={1}>
            <TextField margin='dense'
              //className={MoreClasses.tiersWidth}
              inputRef={register}
              name="mail"
              id="mail"
              type="text"
              label="@mail"
              fullWidth
              variant="outlined"
              //onChange={handleChange}
              error={'reponses' in errors}
              style={{ marginTop: '1.1em' }} /></TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={2}>
            <TextField margin='dense'
              //className={MoreClasses?.tiersWidth}
              inputRef={register}
              name="adresse"
              id="adresse"
              fullWidth
              type="text"
              label="Adresse"
              variant="outlined"
              style={{ marginTop: '1.1em' }} /></TableCell>
          <TableCell colSpan={1}>
            <TextField margin='dense'
              //className={MoreClasses?.tiersWidth}
              inputRef={register}
              id="code_postal"
              name="code_postal"
              type="text"
              label="Code postal"
              fullWidth
              variant="outlined"
              style={{ marginTop: '1.1em' }} /></TableCell>
          <TableCell colSpan={1}>
          <Select style={{top: '0.33rem', width: '14.15rem'}} inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
                  margin="dense" variant="outlined" onChange={selectChange} id="selectedRevenus" 
                  className={classes2.demiWidth} name="selectedRevenus" value={state.selectedRevenus} >
                  <MenuItem key={"Primaire"} value={"Primaire"} /*{...state.selectedRevenus === "Primaire" ? selected : null}*/>Primaire</MenuItem>
                  <MenuItem key={"Secondaire"} value={"Secondaire"} /*{...state.selectedRevenus === "Secondaire" ? selected : null}*/>Secondaire</MenuItem>
                  <MenuItem key={"Rev_inconnus"} value={"Revenus inconnus"}>Revenus inconnus</MenuItem>
                </Select>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={4}>
            <TextField margin='dense'
              //className={MoreClasses?.tiersWidth}
              inputRef={register}
              name="remarques"
              id="remarques"
              type="text"
              label="Remarques"
              variant="outlined"
              fullWidth
              style={{ marginTop: '1.1em' }} /></TableCell>
        </TableRow>
      </TableBody>
      </Table>
      <Divider style={{ margin: '0.5em 0' }} />
        <Typography
          variant={isMobile ? 'h5' : 'h4'}
          color="secondary"
          style={{ marginRight: '0.2em', marginTop: '1.5rem' }}
        >Logement <IconDashboard className={classes2.customIcon} />
        </Typography><br/>
        <Table className={classes2.contactDetailsTable}>
          <TableBody>
            <TableRow>
              <TableCell>
                <TextField
                  inputRef={register}
                  name="sn_site"
                  //fullWidth
                  type="text"
                  label="N° de logement"
                  variant="outlined"
                />
              </TableCell>
              <TableCell><TextField
                //className={classes.fieldMargin}
                type="datetime-local"
                inputRef={register}
                name="dateInstru"
                id="dateInstru"//date_instru"
                onChange={handleDateChg}
                //value={format(new Date(currentData?.date_instru || new Date()), "yyyy-MM-dd'T'h':'mm")}
                defaultValue={format(new Date(), "yyyy-MM-dd'T'h':'mm")}
                label="Date instrumentation"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              /></TableCell>
              <TableCell><TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="gmt_date"
                type="text"
                label="GMT (1 ou 2)"
                variant="outlined"
                style={{ marginTop: '1.1em' }}
                /></TableCell>
              <TableCell><TextField
                //className={classes.fieldMargin}
                hidden
                type="datetime-local"
                inputRef={register}
                id="date_end"
                name="dateEnd"
                /*value={format(new Date(currentData?.date_end || new Date()), "yyyy-MM-dd'T'h':'mm")}*/
                onChange={handleDateChg}
                defaultValue={null/*format(new Date(), "yyyy-MM-dd'T'h':'mm")*/}
                label="Date de fin du logement"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              /></TableCell>
            </TableRow>
              <TableRow>
                <TableCell><TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="cpt_type"
                  type="text"
                  label="Type compteur élec."
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  /></TableCell>
                <TableCell><TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="type_inst_elec"
                  type="text"
                  label="Type installation élec."
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                /></TableCell>
                <TableCell><TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="index_cpt_elec"
                  type="text"
                  label="Index cpt élec."
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  /></TableCell>
                <TableCell><TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="index_cpt_hc"
                  type="text"
                  label="Index cpt HC"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  /></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Select style={{top: '0.4rem', width: '14.15rem'}} inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
                    id="tarif_elec" margin="dense" variant="outlined" onChange={hdlSetChauff}
                    className={classes2.demiWidth} value={state.tarif_elec} name="tarif_elec">
                    <MenuItem key={"Simple_tarif"} value={"Simple tarif"} {...state.tarif_elec === "Simple Tarif" ? 'selected' : null}>Simple tarif</MenuItem>
                    <MenuItem key={"Double_tarif"} value={"Double tarif"} {...state.tarif_elec === "Double Tarif" ? 'selected' : null}>Double tarif</MenuItem>
                    <MenuItem key={"Tempo"} value={"Tempo"} {...state.tarif_elec === "Tempo" ? 'selected' : null}>Tempo</MenuItem>
                    <MenuItem key={"Tarif_inconnu"} value={"Tarif inconnu"} /*{...state.tarif_elec === "Tarif inconnu" ? 'selected' : null}*/>Tarif élec inconnu</MenuItem>
                  </Select>
                </TableCell>
                <TableCell><TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="puiss_sscrite"
                  type="text"
                  label="Puissance souscrite"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  /></TableCell>
                <TableCell><TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="prm_linky"
                  type="text"
                  label="PRM Linky"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  /></TableCell>
                <TableCell><TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="adresseLgt"
                  type="text"
                  label="Adresse"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  /></TableCell>
              </TableRow>
              <TableRow>
                <TableCell><TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="code_postalLgt"
                  type="text"
                  label="Code postal"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  /></TableCell>
                <TableCell><TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="instrum_by"
                  type="text"
                  label="Instrumenté / Visité par"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  /></TableCell>
                <TableCell>
                  <Select style={{top: '0.33rem', width: '14.15rem'}} inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
                    margin="dense" variant="outlined" onChange={selectChange} id="nature"  
                    className={classes2.demiWidth} name="nature" value={state.nature} >
                    <MenuItem key={"Maison"} value={"Maison"} /*{...state.nature === "Maison" ? selected : null}*/>Maison</MenuItem>
                    <MenuItem key={"Appartement"} value={"Appartement"} /*{...state.nature === "Appartement" ? selected : null}*/>Appartement</MenuItem>)
                    <MenuItem key={"Nature_inconnue"} value={"Nature inconnue"} >Nature inconnue</MenuItem>
                  </Select>
                </TableCell>
                <TableCell><TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="surface"
                  type="text"
                  label="Surface"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  /></TableCell>
              </TableRow>
              <TableRow>
                <TableCell><TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="surf_unused"
                  type="text"
                  label="Surf. non utilisée"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  /></TableCell>
                <TableCell><TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="surf_nonchauff"
                  type="text"
                  label="Surf. non chauffée"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  /></TableCell>
                <TableCell><TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="niveaux"
                  type="text"
                  label="Nb niveaux"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  /></TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={4} >
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  multiline
                  name="rq_instru"
                  type="text"
                  rows={6}
                  label="Notes d'instrumentation"
                  variant="outlined"
                  style={{ marginTop: '1.1em', width: '100%' }}
                  /></TableCell>
              </TableRow>
            </TableBody>
        </Table>
        <Table style={{ marginRight: '0.2em', marginTop: '1em', width: '100%' }}
          className={classes2.siteDetailsTable}>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell colSpan={1}>
              Âges
            </TableCell>
            <TableCell colSpan={2}>
              0-10
            </TableCell>
            <TableCell colSpan={2}>
              11-17
            </TableCell>
            <TableCell colSpan={2}>
              18-24
            </TableCell>
            <TableCell colSpan={2}>
              25-59
            </TableCell>
            <TableCell colSpan={2}>
              60-74
            </TableCell>
            <TableCell colSpan={2}>
              &gt;74
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        <TableRow>
        <TableCell className="vert" rowSpan={3} style={{ padding: '0' }}>
          <Typography
            color="secondary"
          >Occupation
          </Typography>
        </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={1}>
            Nombre
          </TableCell>
          <TableCell colSpan={2}>
            <TextField margin='dense'
              //className={MoreClasses?.tiersWidth}
              inputRef={register}
              name="occupy_0_10_nb"
              type="text"
              variant="outlined"
              defaultValue={set.find((s)=>s.range === "0-10")?.nombre || 0/*currOccupation.find((co) => co.range === "0-10")?.nombre*/}
              //onChange={handleChange}
            />
          </TableCell>
          <TableCell colSpan={2}>
            <TextField margin='dense'
              //className={MoreClasses?.tiersWidth}
              inputRef={register}
              name="occupy_11_17_nb"
              type="text"
              variant="outlined"
              defaultValue={set.find((s)=>s.range === "11-17")?.nombre || 0}
              //onChange={handleChange}
            />
          </TableCell>
          <TableCell colSpan={2}>
            <TextField margin='dense'
              //className={MoreClasses?.tiersWidth}
              inputRef={register}
              name="occupy_18_24_nb"
              type="text"
              variant="outlined"
              defaultValue={set.find((s)=>s.range === "18-24")?.nombre || 0}
              //onChange={handleChange}
            />
          </TableCell>
          <TableCell colSpan={2}>
            <TextField margin='dense'
              //className={MoreClasses?.tiersWidth}
              inputRef={register}
              name="occupy_25_59_nb"
              type="text"
              variant="outlined"
              defaultValue={set.find((s)=>s.range === "25-59")?.nombre || 0}
              //onChange={handleChange}
            />
          </TableCell>
          <TableCell colSpan={2}>
            <TextField margin='dense'
              //className={MoreClasses?.tiersWidth}
              inputRef={register}
              name="occupy_60_74_nb"
              type="text"
              variant="outlined"
              defaultValue={set.find((s)=>s.range === "60-74")?.nombre || 0}
              //onChange={handleChange}
            />
          </TableCell>
          <TableCell colSpan={2}>
            <TextField margin='dense'
              //className={MoreClasses?.tiersWidth}
              inputRef={register}
              name="occupy_74_nb"
              type="text"
              variant="outlined"
              defaultValue={set.find((s)=>s.range === ">74")?.nombre || 0}
              //onChange={handleChange}
            />
          </TableCell>
          </TableRow>
          <TableRow className={classes2.lastTrSiteDetails}>
          <TableCell colSpan={1}>
            Temps présence (%)
          </TableCell>
          <TableCell colSpan={2}>
            <TextField margin='dense'
              //className={MoreClasses?.tiersWidth}
              inputRef={register}
              name="occupy_0_10_tx"
              type="text"
              variant="outlined"
              defaultValue={(set.find((s)=>s.range === "0-10")?.taux || 0)*100}
              //onChange={handleChange}
            />
          </TableCell>
          <TableCell colSpan={2}>
            <TextField margin='dense'
              //className={MoreClasses?.tiersWidth}
              inputRef={register}
              name="occupy_11_17_tx"
              type="text"
              variant="outlined"
              defaultValue={(set.find((s)=>s.range === "11-17")?.taux ||0)*100}
              //onChange={handleChange}
            />
          </TableCell>
          <TableCell colSpan={2}>
            <TextField margin='dense'
              //className={MoreClasses?.tiersWidth}
              inputRef={register}
              name="occupy_18_24_tx"
              type="text"
              variant="outlined"
              defaultValue={(set.find((s)=>s.range === "18-24")?.taux ||0)*100}
              //onChange={handleChange}
            />
          </TableCell>
          <TableCell colSpan={2}>
            <TextField margin='dense'
              //className={MoreClasses?.tiersWidth}
              inputRef={register}
              name="occupy_25_59_tx"
              type="text"
              variant="outlined"
              defaultValue={(set.find((s)=>s.range === "25-59")?.taux ||0)*100}
              //onChange={handleChange}
            />
          </TableCell>
          <TableCell colSpan={2}>
            <TextField margin='dense'
              //className={MoreClasses?.tiersWidth}
              inputRef={register}
              name="occupy_60_74_tx"
              type="text"
              variant="outlined"
              defaultValue={(set.find((s)=>s.range === "60-74")?.taux ||0)*100}
              //onChange={handleChange}
            />
          </TableCell>
          <TableCell colSpan={2}>
            <TextField margin='dense'
              //className={MoreClasses?.tiersWidth}
              inputRef={register}
              name="occupy_74_tx"
              type="text"
              variant="outlined"
              defaultValue={(set.find((s)=>s.range === ">74")?.taux ||0)*100}
              //onChange={handleChange}
            />
          </TableCell>
          </TableRow>
        </TableBody>
        </Table>
        <Table style={{ marginRight: '0.2em', marginTop: '1em', width: '100%' }} className={classes2.siteDetailsTable}>
          <TableHead>
            <TableRow>
              <TableCell colSpan={1}></TableCell>
              <TableCell colSpan={1} style={{ backgroundColor: 'transparent' }}>
              </TableCell>
              <TableCell colSpan={2}>
                Principal
              </TableCell>
              <TableCell colSpan={2}>
                Secondaire
              </TableCell>
              <TableCell colSpan={2}>
                Appoint
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          <TableRow>
            <TableCell className="vert" rowSpan={5} style={{ padding: '0' }}>
              <Typography
                color="secondary"
              >Chauffage
              </Typography>
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell colSpan={1}>
              Énergie
            </TableCell>
            <TableCell colSpan={2}>
              <Select /*displayEmpty defaultValue={currSite_id}*/
                /*id="chauff_nrj0"*/ margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.chauff_nrj0} name="chauff_nrj0"
                >
                {chauffFields.map((u) => ( state.chauff_nrj0 !== u.nrj ?
                  <MenuItem key={u.nrj+"_chfnrj0"} value={u.nrj}>{u.nrj}</MenuItem>
                  : <MenuItem key={u.nrj+"_chfnrj0"} value={u.nrj} selected><em>{u.nrj}</em></MenuItem>
                ))}
              </Select>
            </TableCell>
            <TableCell colSpan={2}>
              <Select  /*displayEmpty defaultValue={currSite_id}*/
                /*id="chauff_nrj1"*/ margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.chauff_nrj1} name="chauff_nrj1"
                >
                {chauffFields.map((u) => ( state.chauff_nrj1 !== u.nrj ?
                  <MenuItem key={u.nrj+"_chfnrj1"} value={u.nrj}>{u.nrj}</MenuItem>
                  : <MenuItem key={u.nrj+"_chfnrj1"} value={u.nrj} selected><em>{u.nrj}</em></MenuItem>
                ))}
              </Select>
            </TableCell>
            <TableCell colSpan={2}>
              <Select  /*displayEmpty defaultValue={currSite_id}*/
                /*id="chauff_nrj2"*/ margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.chauff_nrj2} name="chauff_nrj2"
                >
                {chauffFields.map((u) => ( state.chauff_nrj2 !== u.nrj ?
                  <MenuItem key={u.nrj+"_chfnrj2"} value={u.nrj}>{u.nrj}</MenuItem>
                  : <MenuItem key={u.nrj+"_chfnrj2"} value={u.nrj} selected><em>{u.nrj}</em></MenuItem>
                ))}
              </Select>
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell colSpan={1}>
              Détails
            </TableCell>
            <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
              <Select  multiple margin="dense" variant="outlined" onChange={hdlSetChauff} className={classes2.demiWidth}
                name="chauff_detail0" value={state.chauff_detail0}>
                { chauffFields?.find((cf) => String(cf.nrj) === String(state.chauff_nrj0))?.detail.map((j) => (
                  <MenuItem key={j+"chDet_0"} value={j}>{j}</MenuItem> )
                )}
              </Select>
            </TableCell>
            <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
              <Select  /*displayEmpty defaultValue={currSite_id}*/ multiple 
                /*id="chauff_detail1"*/ margin="dense" variant="outlined" /*multiple*/
                onChange={hdlSetChauff} className={classes2.demiWidth} /*defaultValue={infosChauff[0].detail}*/ name="chauff_detail1"
                value={state.chauff_detail1/*infosChauff[1].detail*//*infosChauff*//*infosChauff[0].detail[0]*//*chauffDetail[0][0] ? chauffDetail[0][0] : ""*//* state.chauff_nrj0.find((ic) => ic.nrj === infosChauff[0].nrj)?.detail*/}>
                { chauffFields?.find((cf) => String(cf.nrj) === String(state.chauff_nrj1))?.detail.map((j) => (
                  <MenuItem key={j+"chDet_1"} value={j}>{j}</MenuItem>
                /* infosChauff[1].detail?.map((c) => c !== j ?
                  <MenuItem key={j+"_1"} value={j}>{j}</MenuItem>
                  : <MenuItem key={j+"_1"} value={j} selected><em>{j}</em></MenuItem>*/ )
                )}
              </Select>
            </TableCell>
            <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
              <Select  /*displayEmpty defaultValue={currSite_id}*/ multiple 
                /*id="chauff_detail1"*/ margin="dense" variant="outlined" /*multiple*/
                onChange={hdlSetChauff} className={classes2.demiWidth} /*defaultValue={infosChauff[0].detail}*/ name="chauff_detail2"
                value={state.chauff_detail2/*infosChauff[1].detail*//*infosChauff*//*infosChauff[0].detail[0]*//*chauffDetail[0][0] ? chauffDetail[0][0] : ""*//* state.chauff_nrj0.find((ic) => ic.nrj === infosChauff[0].nrj)?.detail*/}>
                { chauffFields?.find((cf) => String(cf.nrj) === String(state.chauff_nrj2))?.detail.map((j) => (
                  <MenuItem key={j+"chDet_2"} value={j}>{j}</MenuItem>
                /* infosChauff[1].detail?.map((c) => c !== j ?
                  <MenuItem key={j+"_1"} value={j}>{j}</MenuItem>
                  : <MenuItem key={j+"_1"} value={j} selected><em>{j}</em></MenuItem>*/ )
                )}
              </Select>
              </TableCell>  
            </TableRow>
            <TableRow className={classes2.lastTrSiteDetails}>
            <TableCell colSpan={1}>
              Notes
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="chauff_rq0"
                type="text"
                variant="outlined"
                //onChange={handleChange}
                error={'reponses' in errors}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="chauff_rq1"
                type="text"
                variant="outlined"
                //onChange={handleChange}
                error={'reponses' in errors}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="chauff_rq2"
                type="text"
                variant="outlined"
                //onChange={handleChange}
                error={'reponses' in errors}
              />
            </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Table style={{ marginRight: '0.2em', marginTop: '1em', width: '100%' }}
            className={classes2.siteDetailsTable}>
          <TableHead>
            <TableRow>
              <TableCell colSpan={1}>
              </TableCell>
              <TableCell colSpan={1} style={{ backgroundColor: 'transparent' }}>
              </TableCell>
              <TableCell colSpan={2}>
                Principal
              </TableCell>
              <TableCell colSpan={2}>
                Secondaire
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          <TableRow>
          <TableCell className="vert" rowSpan={4} style={{ padding: '0' }}>
            <Typography
              color="secondary"
            >ECS
            </Typography>
          </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={1}>
              Énergie
            </TableCell>
            <TableCell colSpan={2}>
              <Select margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.ecs_nrj0} name="ecs_nrj0" >
                {ecsFields.nrj.map((e) =>
                  <MenuItem key={e+"_ecs0"} value={e}>{e}</MenuItem>
                )}
              </Select>
            </TableCell>
            <TableCell colSpan={2}>
              <Select margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.ecs_nrj1} name="ecs_nrj1">
                {ecsFields.nrj.map((e) =>
                  <MenuItem key={e+"_ecs1"} value={e}>{e}</MenuItem>
                )}
              </Select>
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell colSpan={1}>
              Détails
            </TableCell>
            <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
              <Select multiple margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.ecs_detail0} name="ecs_detail0">
                {ecsFields?.detail.map((d) => <MenuItem key={d+"_ecsdet0"} value={d}>{d}</MenuItem>)}
              </Select>
            </TableCell>
            <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
              <Select multiple margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.ecs_detail1} name="ecs_detail1">
                {ecsFields?.detail.map((d) => <MenuItem key={d+"_ecsdet1"} value={d}>{d}</MenuItem>)}
              </Select>
            </TableCell>
            </TableRow>
            <TableRow className={classes2.lastTrSiteDetails}>
            <TableCell colSpan={1}>
              Notes
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="ecs_rq0"
                type="text"
                variant="outlined"
                //onChange={handleChange}
                error={'reponses' in errors}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="ecs_rq1"
                type="text"
                variant="outlined"
                //onChange={handleChange}
                error={'reponses' in errors}
              />
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell className="vert" rowSpan={4} style={{ padding: '0' }}>
              <Typography
                color="secondary"
              >Cuisson
              </Typography>
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell colSpan={1}>
              Énergie plaques
            </TableCell>
            <TableCell colSpan={2}>
              <Select /*inputRef={register} displayEmpty defaultValue={currSite_id}*/
                margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.cuissonplq_nrj0} name="cuissonplq_nrj0">
                {plaquesFields.type.map((u) => ( infosPlaques[0].type !== u ?
                  <MenuItem key={u+"_0"} value={u}>{u}</MenuItem>
                  : <MenuItem key={u+"_0"} value={u} selected><em>{u}</em></MenuItem>
                ))}
              </Select>
            </TableCell>
            <TableCell colSpan={2}>
              <Select /*inputRef={register} displayEmpty defaultValue={currSite_id}*/
                margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.cuissonplq_nrj1} name="cuissonplq_nrj1">
                {plaquesFields.type.map((u) => ( infosPlaques[1].type !== u ?
                  <MenuItem key={u+"_1"} value={u}>{u}</MenuItem>
                  : <MenuItem key={u+"_1"} value={u} selected><em>{u}</em></MenuItem>
                ))}
              </Select>
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell colSpan={1}>
              Nombre de feux
            </TableCell>
            <TableCell colSpan={2}>
            <Select /*inputRef={register} displayEmpty defaultValue={currSite_id}*/
                margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.cuissonplq_detail0} name="cuissonplq_detail0">
                {plaquesFields.nbFeux.map((u) => ( infosPlaques[0].nbFeux !== u ?
                  <MenuItem key={u+"_0"} value={u}>{u}</MenuItem>
                  : <MenuItem key={u+"_0"} value={u} selected><em>{u}</em></MenuItem>
                ))}
              </Select>
            </TableCell>
            <TableCell colSpan={2}>
            <Select inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
                id="cuissonplq_nbFeux1" margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.cuissonplq_detail1} name="cuissonplq_detail1">
                {plaquesFields.nbFeux.map((u) => ( infosPlaques[1].nbFeux !== u ?
                  <MenuItem key={u+"_1"} value={u}>{u}</MenuItem>
                  : <MenuItem key={u+"_1"} value={u} selected><em>{u}</em></MenuItem>
                ))}
              </Select>
            </TableCell>
            </TableRow>
            <TableRow className={classes2.lastTrSiteDetails}>
            <TableCell colSpan={1}>
              Notes
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="cuissonplq_rq0"
                type="text"
                variant="outlined"
                //onChange={handleChange}
                error={'reponses' in errors}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="cuissonplq_rq1"
                type="text"
                variant="outlined"
                //onChange={handleChange}
                error={'reponses' in errors}
              />
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell className="vert" rowSpan={4} style={{ padding: '0' }}>
              <Typography
                color="secondary"
              >Four
              </Typography>
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell colSpan={1}>
              Type
            </TableCell>
            <TableCell colSpan={2}>
              <Select /*inputRef={register} displayEmpty defaultValue={currSite_id}*/
                margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.four_type0} name="four_type0">
                {fourFields.type.map((u) => ( infosFour[0].type !== u ?
                  <MenuItem key={u+"_0"} value={u}>{u}</MenuItem>
                  : <MenuItem key={u+"_0"} value={u} selected><em>{u}</em></MenuItem>
                ))}
              </Select>
            </TableCell>
            <TableCell colSpan={2}>
              <Select /*inputRef={register} displayEmpty defaultValue={currSite_id}*/
                margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.four_type1} name="four_type1">
                {fourFields.type.map((u) => ( infosFour[1].type !== u ?
                  <MenuItem key={u+"_1"} value={u}>{u}</MenuItem>
                  : <MenuItem key={u+"_1"} value={u} selected><em>{u}</em></MenuItem>
                ))}
              </Select>
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell colSpan={1}>
              Détails
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="four_detail0"
                type="text"
                variant="outlined"
                //onChange={handleChange}
                error={'reponses' in errors}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="four_detail1"
                type="text"
                variant="outlined"
                //onChange={handleChange}
                error={'reponses' in errors}
              />
            </TableCell>
            </TableRow>
            <TableRow className={classes2.lastTrSiteDetails}>
            <TableCell colSpan={1}>
              Remarque
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="four_rq0"
                type="text"
                variant="outlined"
                //onChange={handleChange}
                error={'reponses' in errors}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="four_rq1"
                type="text"
                variant="outlined"
                //onChange={handleChange}
                error={'reponses' in errors}
              />
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell className="vert" rowSpan={4} style={{ padding: '0' }}>
              <Typography
                color="secondary"
              >Ventilation
              </Typography>
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell colSpan={1}>
              Type
            </TableCell>
            <TableCell colSpan={2}>
              <Select margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.ventil_type0} name="ventil_type0">
                {ventilFields.type.map((u) => ( infosVentil[0].type !== u ?
                  <MenuItem key={u+"_0"} value={u}>{u}</MenuItem>
                  : <MenuItem key={u+"_0"} value={u} selected><em>{u}</em></MenuItem>
                ))}
              </Select>
            </TableCell>
            <TableCell colSpan={2}>
              <Select margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.ventil_type1} name="ventil_type1">
                {ventilFields.type.map((u) => ( infosVentil[1].type !== u ?
                  <MenuItem key={u+"_1"} value={u}>{u}</MenuItem>
                  : <MenuItem key={u+"_1"} value={u} selected><em>{u}</em></MenuItem>
                ))}
              </Select>
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell colSpan={1}>
              Détails
            </TableCell>
            <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
              <Select multiple margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.ventil_detail0} name="ventil_detail0">
                {ventilFields?.detail.map((d) => <MenuItem key={d+"_0"} value={d}>{d}</MenuItem>)}
              </Select>
            </TableCell>
            <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
              <Select multiple margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.ventil_detail1} name="ventil_detail1">
                {ventilFields?.detail.map((d) => <MenuItem key={d+"_1"} value={d}>{d}</MenuItem>)}
              </Select>
            </TableCell>
            </TableRow>
            <TableRow className={classes2.lastTrSiteDetails}>
            <TableCell colSpan={1}>
              Remarque
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="ventil_rq0"
                type="text"
                variant="outlined"
                //onChange={handleChange}
                error={'reponses' in errors}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="ventil_rq1"
                type="text"
                variant="outlined"
                //onChange={handleChange}
                error={'reponses' in errors}
              />
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell className="vert" rowSpan={4} style={{ padding: '0' }}>
              <Typography
                color="secondary"
              >Climatisation
              </Typography>
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell colSpan={1}>
              Type
            </TableCell>
            <TableCell colSpan={2}>
              <Select margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.clim_type0} name="clim_type0">
                {climFields?.type.map((d) => ( infosClim[0].type !== d ?
                  <MenuItem key={d+"_0"} value={d}>{d}</MenuItem>
                  : <MenuItem key={d+"_0"} value={d} selected><em>{d}</em></MenuItem>
                ))}
              </Select>
            </TableCell>
            <TableCell colSpan={2}>
            <Select margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.clim_type1} name="clim_type1">
                {climFields?.type.map((d) => ( infosClim[1].type !== d ?
                  <MenuItem key={d+"_1"} value={d}>{d}</MenuItem>
                  : <MenuItem key={d+"_1"} value={d} selected><em>{d}</em></MenuItem>
                ))}
              </Select>
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell colSpan={1}>
              Détails
            </TableCell>
            <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
              <Select multiple margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.clim_detail0} name="clim_detail0">
                {climFields?.detail.map((d) => <MenuItem key={d+"_0"} value={d}>{d}</MenuItem>
                  /*( infosClim[0].detail?.some(item => d === item) ?
                  <MenuItem key={d+"_0"} value={d}>{d}</MenuItem>
                  : <MenuItem key={d+"_0"} value={d} selected><em>{d}</em></MenuItem>
                )*/)}
              </Select>
            </TableCell>
            <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
              <Select multiple margin="dense" variant="outlined" onChange={hdlSetChauff}
                className={classes2.demiWidth} value={state.clim_detail1} name="clim_detail1">
                {climFields?.detail.map((d) => <MenuItem key={d+"_1"} value={d}>{d}</MenuItem>
                  /*( infosClim[0].detail?.some(item => d === item) ?
                  <MenuItem key={d+"_1"} value={d}>{d}</MenuItem>
                  : <MenuItem key={d+"_1"} value={d} selected><em>{d}</em></MenuItem>
                )*/)}
              </Select>
            </TableCell>
            </TableRow>
            <TableRow className={classes2.lastTrSiteDetails}>
            <TableCell colSpan={1}>
              Remarque
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="clim_rq0"
                type="text"
                variant="outlined"
                //onChange={handleChange}
                error={'reponses' in errors}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="clim_rq1"
                type="text"
                variant="outlined"
                //onChange={handleChange}
                error={'reponses' in errors}
              />
            </TableCell>
            </TableRow>
          </TableBody>
        </Table>
          <Typography
              //variant={isMobile ? 'h7' : 'h6'}
              variant={/*isMobile ? 'h7' : */'h6'}
              color="secondary"
              style={{ marginRight: '0.2em', marginTop: '1em' }}
            >Piscine
          </Typography>
          <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <InputLabel shrink>Présence</InputLabel>
                <Select inputRef={register} margin="dense" variant="outlined" label="Présence" name="piscine_infos_present"
                  value={state.piscine_infos_present} onChange={hdlSetChauff} >
                  {piscineFields.present.map((f) => (
                    infosPiscine.present === f ? <MenuItem key={"presencePiscine_"+f} value={f} {...infosPiscine.present === "Oui" ? 'selected' : null }>{f}</MenuItem>
                    : <MenuItem key={"presencePiscine_"+f} value={f}>{f}</MenuItem> ))}
                </Select>
              </TableCell>
              { state.piscine_infos_present === "Oui" && <>
              <TableCell>
                <InputLabel shrink>Type</InputLabel>
                <Select inputRef={register} margin="dense" variant="outlined" /*onChange={handleChangePiscine}*/ name="piscine_infos_type"
                  value={state.piscine_infos_type} onChange={hdlSetChauff} >
                  {piscineFields.type.map((f) => (
                    infosPiscine.type === f ? <MenuItem key={"typePiscine_"+f} value={f} selected>{f}</MenuItem>
                    : <MenuItem key={"typePiscine_"+f} value={f}>{f}</MenuItem> ))}
                </Select>
              </TableCell>
              <TableCell>
                <InputLabel shrink>Chauffée</InputLabel>
                <Select inputRef={register} margin="dense" variant="outlined" label="Présence" /*onChange={handleChangePiscine}*/ name="piscine_infos_chauffage"
                  value={state.piscine_infos_chauffage} onChange={hdlSetChauff} >
                  {piscineFields.chauffage.map((f) => (
                    infosPiscine.chauffage === f ? <MenuItem key={"chauffagePiscine_"+f} value={f} selected>{f}</MenuItem>
                    : <MenuItem key={"chauffagePiscine_"+f} value={f}>{f}</MenuItem> ))}
                </Select>
              </TableCell>
              <TableCell>
                <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="piscine_infos_lgdia"
                type="text"
                label="Long/Diam (m)"
                variant="outlined"
                style={{ marginTop: '1.1em' }}
                />
              </TableCell>
              <TableCell>
                <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="piscine_infos_larg"
                type="text"
                label="Largeur (m)"
                variant="outlined"
                style={{ marginTop: '1.1em' }}
                />
              </TableCell>
              <TableCell>
                <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="piscine_infos_prof"
                type="text"
                label="Prof. (m)"
                variant="outlined"
                style={{ marginTop: '1.1em' }}
                />
              </TableCell>
              <TableCell>
                <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="piscine_infos_consoppe"
                type="text"
                label="Conso Pompe (W)"
                variant="outlined"
                style={{ marginTop: '1.1em' }}
                />
              </TableCell>
              </>}
              </TableRow>
              <TableRow>
              <TableCell colSpan={7}>
                <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="piscine_infos_note"
                type="text"
                multiline
                fullWidth
                rows={3}
                label="Notes sur la piscine"
                variant="outlined"
                style={{ marginTop: '1.1em' }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
          </Table>
          <div style={{ maxWidth: '100%', height: '10rem' }}>
          { isEditMode ?
          (<Controller
            style={{ maxWidth: '29vw' }}
            control={control}
            name="controlUpdateOrCreate"
            as={
              <FormControl className={classes.radioGroupForm}>
                <RadioGroup className={classes.radioGroup}
                  aria-labelledby="radio-buttons-group-label"
                  name="scenario"
                  value={selectedScenario} 
                  onChange={radioHandlerScenar}
                  >
                  <div className={classes.formControlLabels}>
                    <FormControlLabel
                      value="update"
                      control={<Radio color="primary" />}
                      label="Mettre à jour les infos à la date"
                    />
                    <FormControlLabel
                      value="creation"
                      control={<Radio color="primary" />}
                      label="Créer une nouvelle vue datée"
                    />
                  </div>
                </RadioGroup>
              </FormControl>
            }
          />) : null }              
          <Button
          size="large"
          color="primary"
          variant="contained"
          //fullWidth
          className={classes.submitBtn}
          type="submit"
          disabled={submitLoading}
        >
            Créer contact & logement à la date d'état
        </Button>
        {submitError && (
          <ErrorBox
            errorMsg={submitError}
            clearErrorMsg={() => dispatch(clearSubmitSiteError())} />
        )}
        <TextField margin='dense'
          //className={MoreClasses?.tiersWidth}
          inputRef={register}
          id="date_update"
          name="dateUpdate"
          type="datetime-local"
          label="Date d'état infos"
          variant="outlined"
          onChange={handleDateChg}
        //  defaultValue={format(state.dateUpdate, "yyyy-MM-dd'T'h':'mm")}
//          defaultValue={format(new Date(state.dateUpdate), "yyyy-MM-dd'T'h':'mm")}
          //value={format(new Date(state.dateUpdate), "yyyy-MM-dd'T'h':'mm")}
          style={{ marginLeft: '14rem', marginRight: '2rem', top: '0.53rem', marginTop: '1.1em', float: 'left' }}
          InputLabelProps={{
            shrink: true,
          }}
          disabled={selectedScenario === "update" ? true : false}
          />
        </div>
    </form>
    </></>
    );
  }
  return (<Paper className={classes3.detailsHeader}>
        <div><Typography
            variant={isMobile ? 'h5' : 'h4'}
            color="secondary"
            style={{ marginRight: '0.2em' }}
        >
            <strong>Nouveau logement</strong>
        </Typography>
        </div>
        <Divider style={{ margin: '0.5em 0' }} />
        {<LogementForm/>}
        </Paper>
    );
};

export default SiteCreation;
